import React from "react";
import { SocialIcon } from "react-social-icons";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-white py-10">
      <div className="max-w-6xl mx-auto flex justify-between">
        <div className="space-y-2">
          <p className="text-sm">&copy; {currentYear} Consortium on Electoral Democracy</p>
          <a href="mailto:admin@c-dem.ca" className="text-gray-400 hover:text-white">
            admin@c-dem.ca
          </a>
        </div>
        <div>
          <p className="text-sm">Follow us:</p>
          <div className="mt-2 flex items-center">
            <SocialIcon
              url="https://www.linkedin.com/company/c-dem/"
              bgColor="transparent"
              fgColor="#e5e7eb"
              style={{ height: 34, width: 34 }}
              className="transition-opacity duration-200 hover:opacity-80"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
